
    import './styles.scoped.css';
    export default {
  "root": "_root_faj8j_3",
  "textarea": "_textarea_faj8j_7",
  "textarea-readonly": "_textarea-readonly_faj8j_30",
  "textarea-invalid": "_textarea-invalid_faj8j_59"
};
  